/* unplugin-vue-components disabled */import script from "./ChatPrompt.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatPrompt.vue?vue&type=script&setup=true&lang=js"

import "./ChatPrompt.vue?vue&type=style&index=0&id=5d74ca28&lang=stylus"

const __exports__ = script;

export default __exports__